import C from "classnames";
import { Button } from "primereact/button";
import { useEffect, useRef } from "react";

import { Banner } from "../../../api/types";
import { themeClasses as T } from "../../utils";

interface UserBannerProps {
  banner: Banner | null;
  handleClear?: () => void;
  fullWidth?: boolean;
  /** Prefix used to build data-testids for the banner and its dismiss button. */
  testId?: string;
}

export function UserBanner({
  banner,
  handleClear,
  fullWidth = false,
  testId = "user-banner",
}: UserBannerProps) {
  const bannerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Set --banner-height CSS variable to the banner height plus margin (8px for mb-2)
    const root = document.documentElement;
    const height = bannerRef.current ? bannerRef.current.offsetHeight + 8 : 0;
    root.style.setProperty("--banner-height", `${height}px`);
    // Optionally, clean up on unmount
    return () => {
      root.style.setProperty("--banner-height", `0px`);
    };
  }, [banner]);

  if (!banner) return null;

  return (
    <div
      ref={bannerRef}
      data-testid={testId}
      className={C("mb-2 py-4 px-10 relative border-b border-surface-border", T.bgElevation1, [
        fullWidth ? "px-10" : "",
      ])}
    >
      <Button
        icon="pi pi-times"
        onClick={handleClear}
        data-testid={`${testId}-dismiss-button`}
        className="p-button-text p-button-rounded absolute top-2 right-2"
        aria-label="Dismiss notification"
      />
      {banner.title && <h3 className="atlas-h3">{banner.title}</h3>}
      {banner.description && <p>{banner.description}</p>}
    </div>
  );
}
